import { TF } from 'react-translator-component';

/**
 * Formatos dos painéis de detalhe (MV2-1706).
 *
 * A listagem fala em relativo — "há 3 min", "expira em 2 d" —, que é o que se lê de
 * relance. O detalhe fala em absoluto: é ali que a pessoa casa o registro com a
 * trilha, com o log e com o que o parceiro contou por telefone.
 */

/** "19/08/2026 13:41" — mesmo formato da coluna de data da trilha. */
export const fullMoment = (value: string | null): string => {
  if (!value) {
    return '—';
  }

  const moment = new Date(value);

  if (Number.isNaN(moment.getTime())) {
    return '—';
  }

  const pad = (part: number): string => String(part).padStart(2, '0');

  return `${pad(moment.getDate())}/${pad(moment.getMonth() + 1)}/${moment.getFullYear()} ${pad(
    moment.getHours(),
  )}:${pad(moment.getMinutes())}`;
};

/**
 * Sim, não, ou travessão.
 *
 * Nulo não vira "não": "não herda subconta" é decisão de quem gerou o convite, e
 * ausência de dado é ausência de dado.
 */
export const yesNo = (value: boolean | null | undefined): string => {
  if (value === null || value === undefined) {
    return '—';
  }

  return value ? TF('Yes') : TF('No');
};
